export default __webpack_public_path__ + "static/media/1164-00.05c71491.gif";